import React from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import classes from "./DoctorReportSummary.module.css";

const DoctorReportSummary = ({
  showAutoComplete = () => {},
  quickExport = () => {},
  refreshData = () => {},
  exportRef,
  refreshRef,
}) => {
  // const { addRef } = useContext(ProductsContext);
  return (
    <div className={classes["summary-container"]}>
      <div className={classes["summary-ctas"]}>
        <FilterGroup>
        <FilterItem>
            <Button
              ref={exportRef}
              label="Quick Export"
              color="black"
              onClick={quickExport}
              endIcon={<Shortcut keys={["Alt", "E"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
              ref={refreshRef}
              label="Refresh"
              color="black"
              onClick={() => {
                refreshData();
              }}
              endIcon={<Shortcut keys={["Alt", "R"]} />}
            />
          </FilterItem>
          <FilterItem>
            <Button
             label="Add New Doctor"
              color="violet"
              onClick={showAutoComplete}
              endIcon={<Shortcut keys={["Ctrl", "D"]} />}
            />
          </FilterItem>
        </FilterGroup>
      </div>
    </div>
  );
};

export default DoctorReportSummary;
